// GoldRateForm.jsx
import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

const GoldRateForm = ({ initialValues, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    r22kRate: "",
    r24kRate: "",
    date: "",
  });

  // Populate form when editing
  useEffect(() => {
    if (initialValues) {
      setFormData(initialValues);
    } else {
      setFormData({
        r22kRate: "",
        r24kRate: "",
        date: "",
      });
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleClear = () => {
    setFormData({
      r22kRate: "",
      r24kRate: "",
      date: "",
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="r22kRate">
            <Form.Label>
              22k Rate <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="r22kRate"
              value={formData.r22kRate}
              onChange={handleChange}
              placeholder="Enter 22k rate"
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group controlId="r24kRate">
            <Form.Label>
              24k Rate <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="r24kRate"
              value={formData.r24kRate}
              onChange={handleChange}
              placeholder="Enter 24k rate"
              required
            />
          </Form.Group>
        </Col>

        <Col md={6} className="mt-3">
          <Form.Group controlId="date">
            <Form.Label>
              Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Buttons */}
      <Row>
        <Col className="text-end mt-3">
          <Button type="submit" variant="primary" className="me-2">
            {initialValues ? "Update" : "Submit"}
          </Button>
          <Button type="button" variant="secondary" className="me-2" onClick={handleClear}>
            Clear
          </Button>
          <Button type="button" variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default GoldRateForm;